module.exports = __webpack_public_path__ + "img/attachment-icon.32d8f9fb.svg";